(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["touge-product-reels"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('touge-product-reels')) {
    customElements.define(
      'touge-product-reels',
      class extends HTMLElement {
        connectedCallback() {
          this.videos = Array.from(this.querySelectorAll('.touge-reels__video'));
          if (!this.videos.length) return;

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const video = entry.target;
                if (entry.isIntersecting) {
                  if (!video.src && video.dataset.src) {
                    video.preload = 'auto';
                    video.src = video.dataset.src;
                    video.addEventListener(
                      'loadedmetadata',
                      () => {
                        if (video.currentTime === 0) video.currentTime = 0.05;
                      },
                      { once: true }
                    );
                  }
                  const playback = video.play();
                  if (playback) playback.catch(() => {});
                } else if (!video.paused) {
                  video.pause();
                }
              });
            },
            { rootMargin: '200px 0px' }
          );

          this.videos.forEach((video) => this.observer.observe(video));
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["touge-size-guide"] && !Shopify.designMode) return;
  try {
    (()=>{document.querySelectorAll('[data-touge-size-guide]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const modal=root.querySelector('[data-touge-size-guide-modal]');const open=root.querySelector('[data-touge-size-guide-open]');const close=root.querySelector('[data-touge-size-guide-close]');if(!modal||!open)return;open.addEventListener('click',()=>modal.showModal());close?.addEventListener('click',()=>modal.close());modal.addEventListener('click',event=>{if(event.target===modal)modal.close()})})})();
  } catch(e) { console.error(e); }
})();

})();
